import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';

type ReportsPageEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const reportsCustomPageEntryPoint: EntryPoint<ReportsPageEntryPointComponent, {}> = {
	root: JSResourceForUserVisible<ReportsPageEntryPointComponent>(
		/* webpackChunkName: "async-csm-reports-custom-entrypoint" */
		'./ReportsCustomPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
};
